'use strict'; /* eslint-disable no-console, no-unused-vars */

const calendar = (function(){

  /*
  * Documentation: https://github.com/dbushell/Pikaday
  */
  var pikaday = require('pikaday');

  // initialize datepicker

  window.addEventListener('load', () => {
    const datepicker = document.querySelectorAll('.js-datepicker');
    // console.log(datepicker);
    if (document.querySelector('.domain_us') !== null) {
      [].forEach.call(datepicker, (field) => {
        new pikaday({
          field: field,
          format: 'MM/DD/YYYY',
        });
      });
    } else {
      [].forEach.call(datepicker, (field) => {
        new pikaday({
          field: field,
          format: 'DD/MM/YYYY',
        });
      });
    }

  })
})();

export default calendar;


// WEBPACK FOOTER //
// ./resources/assets/js/pikaday.js